module.exports = __webpack_public_path__ + "static/media/map-icon.21183f13.svg";